<template>
  <div class="flex flex-row items-center gap-x-1">
    <ui-toolbar-button
      :selected="toolbarMode === ToolbarMode.Overlays || isSomeOverlayFilterActive"
      class="xs:hidden"
      @click="toolbarMode === ToolbarMode.Overlays ? (toolbarMode = ToolbarMode.None) : (toolbarMode = ToolbarMode.Overlays)"
      ><gv-icon-sharp
        aria-label="Overlays"
        name="layers"
        :class="toolbarMode === ToolbarMode.Overlays || isSomeOverlayFilterActive ? 'fill-white' : 'fill-secondary'"
        :fill="toolbarMode === ToolbarMode.Overlays || isSomeOverlayFilterActive"
    /></ui-toolbar-button>
    <ui-search-dropdown
      class="hidden xs:block"
      :gv-dropdown-props="{ minWidth: '300px' }"
      :filters="overlaySections"
      :placeholder="overlaySearchPlaceholder"
      @update:search="(value) => (overlaysSearch = value)"
    >
      <template #default="{ open, toggleOpen }">
        <gv-tooltip
          :floating-ui-options="{
            placement: 'bottom',
          }"
          class="h-8"
          label="Layers"
        >
          <button
            class="flex flex-row items-center rounded border-[0.5px] p-1"
            :class="open || isSomeOverlayFilterActive ? 'bg-primary-400 border-indigo-500' : 'bg-grey-35 border-transparent'"
            @click.stop="toggleOpen()"
          >
            <gv-icon-sharp
              name="layers"
              :class="open || isSomeOverlayFilterActive ? 'fill-white' : 'fill-secondary'"
              :fill="open || isSomeOverlayFilterActive"
              aria-label="Layers"
            />
          </button>
        </gv-tooltip>
      </template>
      <template #items>
        <ui-dropdown-items :filters="overlaySections" :dropdown-type="ToolbarMode.Overlays" padding="px-6" :search="overlaysSearch" />
      </template>
    </ui-search-dropdown>
    <ui-toolbar-button tooltip="Pause updates" :selected="isPaused" :aria-selected="isPaused" @click="handlePause">
      <gv-icon-sharp name="pause" :class="isPaused ? 'fill-white' : 'fill-secondary'" :fill="isPaused" aria-label="Pause updates" />
    </ui-toolbar-button>
    <ui-toolbar-button tooltip="Check for updates" :selected="hazardsStore.retryButton" @click="onClickRefresh">
      <gv-icon-sharp name="replay" :class="hazardsStore.retryButton ? 'fill-white' : 'fill-secondary'" aria-label="Retry" />
    </ui-toolbar-button>
  </div>
</template>

<script setup lang="ts">
import { usePoller } from '@/common';
import {
  HazardType,
  overlaySearchPlaceholder,
  overlaySections,
  Poller,
  ToolbarMode,
  useHazardsStore,
  useMapStore,
  useToolbarStore,
} from '@/features';
import { storeToRefs } from 'pinia';
import { debounce } from 'remeda';
import { computed, ref } from 'vue';

const hazardsStore = useHazardsStore();
const { isSomeOverlayFilterActive } = storeToRefs(useMapStore());
const { toolbarMode } = storeToRefs(useToolbarStore());
const poller = usePoller();

const handlePause = () => {
  poller.togglePoller(Poller.fetchAllHazards);
};

const isPaused = computed(() => !poller.isPolling(Poller.fetchAllHazards));

const overlaysSearch = ref<string>('');

const onClickRefresh = () => {
  debounce(
    () => {
      hazardsStore.fetchAllHazards([
        HazardType.Event,
        HazardType.Warning,
        HazardType.Incident,
        HazardType.Closure,
        HazardType.Centre,
        HazardType.TotalFireBans,
        HazardType.FireDangerRating,
        HazardType.PrescribedBurns,
      ]);
    },
    { waitMs: 2000 }
  ).call();
};
</script>
